<template>
  <CCol sm="12" class="mt-5 mb-5">
    <CRow class="justify-content-center mt-5">
      <CCol sm="10">
        <CBreadcrumb :items="items3" />
      </CCol>
      <CCol sm="10">
        <h2 class="askTitle">{{ $t(`faqs.quetions.pages.${pageTitle}.titlePage`) }}</h2>
        <div class="askSubTitle mt-3 mb-4">{{ $t(`faqs.quetions.pages.${pageTitle}.subTitlePage`) }}</div>
        <CCard class="w-100 mb-3 mt-3 p-3" v-for="(item, i) in items" :key="item.title + i">
          <CButton block class="text-left shadow-none card-header" @click="accordion = accordion === item.title ? false : item.title">
            <h5 class="m-0 acordeonItem">{{ item.title }}</h5>
            <CIcon v-if="accordion != item.title || accordion === false" class="plusIcon mr-2" name="plus" :height="15" viewBox="0 0 32 32" />
            <CIcon v-if="accordion == item.title" class="plusIcon mr-2" name="minus" :height="15" viewBox="0 0 32 32" />
          </CButton>
          <CCollapse :show="accordion === item.title">
            <CCardBody class="pr-5 mr-5">
              <div v-html="item.answers"></div>
            </CCardBody>
          </CCollapse>
        </CCard>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TopicItems',
  data() {
    return {
      collapse: false,
      cardCollapse: true,
      innerCollapse: false,
      accordion: '',
      pageTitle: null,
      items: [],
      items3: [
        {
          text: this.$t(`faqs.quetions.breadCrumb.help`),
          to: { name: 'help' },
          addClasses: 'font-sm font-black',
        },
        {
          text: this.$t(`faqs.quetions.pages.${this.$route.params.contentName}.titlePage`),
          to: '#3',
          addClasses: 'font-sm',
        },
      ],
    }
  },
  mounted() {
    this.pageTitle = this.$route.params.contentName
    this.updateItems()
  },
  components: {},
  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
  },
  methods: {
    updateItems() {
      this.items = this.$t(`faqs.quetions.pages.${this.$route.params.contentName}.content`)
    },
  },
  watch: {
    lang: {
      handler() {
        this.updateItems()
      },
    },
  },
}
</script>

<style lang="scss">
.askSubTitle {
  color: #868e96;
  font-size: 18px;
}

.plusIcon {
  position: absolute;
  right: 25px;
  top: 40%;
}

.acordeonItem {
  color: #343a40;
}
</style>
